// extracted by css-extract-rspack-plugin
export default {"StackedColumnSeries":"StackedColumnSeries--OA2iT"};